import { Moment } from 'moment';
import User from '@/shared/models/User';

export default class DossierEvent {
  createdOn!: Moment;
  createdBy!: User;
  description = '';
  comment = '';
}
